export default __webpack_public_path__ + "static/media/bardashboardcardpuspenerbal.50a5de90.svg";